<template>
  <v-card
    v-if="referrals.length > 0"
    elevation="0"
  >
    <v-card-title>
      <p class="pa-0 ma-0 text--secondary text-sm">
        {{ currentClub.referralAlias }}
      </p>
      <v-spacer />
      <v-btn
        icon
        fab
        :ripple="false"
        @click="opener = !opener"
      >
        <v-icon>
          {{ icons.mdiCogOutline }}
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-expand-transition>
      <v-card-text v-show="!opener">
        <div v-if="referringHistories.length > 0">
          <v-list-item
            v-for="(referringHistory, referringHistoryIdx) in referringHistories"
            :key="`referringHistories[${referringHistoryIdx}]`"
            dense
            class="pl-1"
          >
            <v-list-item-avatar
              size="20"
              class="mr-2"
            >
              <v-img
                v-if="referringHistory.attributes.user.data.attributes.profileImage"
                :src="referringHistory.attributes.user.data.attributes.profileImage"
              />
              <v-icon v-else>
                {{ icons.mdiAccountCircleOutline }}
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content
              class="ma-0 pa-0"
            >
              <v-list-item-title>
                {{ referringHistory.attributes.user.data.attributes.name }}
                <v-chip small>
                  {{ referringHistory.attributes.referral.data.attributes.name }}
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div
          v-else
          class="ml-2"
        >
          ...
        </div>
      </v-card-text>
    </v-expand-transition>

    <v-expand-transition>
      <v-card-text v-show="opener">
        <!-- eslint-disable vue/v-on-event-hyphenation -->
        <referral-card
          v-for="(referringHistoryTemp, referringHistoryTempIdx) in referringHistoriesTemp"
          :key="`referringHistoriesTemp[${referringHistoryTempIdx}]`"
          :value="referringHistoryTemp"
          :referrals="referrals"
          :users="users"
          :referring-history-temp-idx="referringHistoryTempIdx"
          class="mb-4"
          @update:referralId="referringHistoryTemp.referralId = $event"
          @update:userId="referringHistoryTemp.userId = $event"
          @update:_destroy="referringHistoryTemp._destroy = $event"
          @remove="$emit('remove:referring-history-temp', referringHistoryTempIdx)"
        />

        <v-card
          elevation="0"
          class="d-flex align-center justify-center mb-2"
        >
          <v-btn
            fab
            icon
            large
            color="primary"
            :ripple="false"
            @click="$emit('add:referring-history-temp', {})"
          >
            <v-icon>
              {{ icons.mdiPlus }}
            </v-icon>
          </v-btn>
        </v-card>
      </v-card-text>
    </v-expand-transition>
  </v-card>
</template>

<script>
import {
  inject,
  ref,
  watch,
  getCurrentInstance,
  onUnmounted,
} from '@vue/composition-api'
import { each, find, cloneDeep } from 'lodash'
import { mdiCogOutline, mdiAccountCircleOutline, mdiPlus } from '@mdi/js'
import useReferral from '@/views/composable/useReferral'
import useCurrentData from '@/views/composable/useCurrentData'
import ReferralCard from '@/views/components/table/ReferralCard.vue'

export default {
  components: {
    ReferralCard,
  },
  props: {
    tableId: {
      type: [Number, String],
      validator: value => !Number.isNaN(Number(value)),
      required: true,
    },
    referringHistoriesTemp: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy

    const referringHistories = inject('referringHistories', [])
    const referrals = inject('referrals', [])
    const users = inject('users', [])

    const opener = ref(false)

    const {
      addReferringHistoryTemp,
      removeReferringHistoryTemp,
      resetReferringHistoriesTemp,
      isValidToSubmit,
    } = useReferral()
    const { currentClub } = useCurrentData()

    const resetComp = () => {
      opener.value = false

      resetReferringHistoriesTemp()
    }

    watch(() => referringHistories.value, newVal => {
      each(newVal, referringHistory => {
        emit('add:referring-history-temp', {
          id: referringHistory.id,
          userId: referringHistory.attributes.user.data.id,
          referralId: referringHistory.attributes.referral.data.id,
        })
      })
    })

    onUnmounted(() => resetComp())

    return {
      referringHistories,
      referrals,
      users,

      opener,

      removeReferringHistoryTemp,
      addReferringHistoryTemp,
      isValidToSubmit,

      icons: {
        mdiCogOutline,
        mdiAccountCircleOutline,
        mdiPlus,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.v-expansion-panel::before {
  box-shadow: none !important;
}
</style>
